import {ChatApiService, chatServiceReverb} from "./api/ChatService";
import store from "@/store";

export const getChatUsers = async (payload = {}) => {
    try {
        let url = '/users?';

        payload.search && (url += `search=${payload.search}&`)
        payload.page && (url += `page=${payload.page}&`)
        payload.perPage && (url += `per_page=${payload.perPage}&`)

        const response = await ChatApiService.get(url);
        return response.data;
    } catch {
        throw new Error("Ocorreu um erro ao requisitar usuarios")
    }
};

export const getSocialChats = async (payload = {}) => {
    try {
        let url = '/chats?';

        payload.type && (url += `type=${payload.type}&`)
        payload.status && (url += `status=${payload.status}&`)

        const response = await ChatApiService.get(url);
        return response.data;
    } catch {
        throw new Error("Ocorreu um erro ao requisitar chats")
    }
};

export const getChatMessages = async (payload = {}) => {
    try {
        let url = '/messages?';

        payload.chatId && (url += `chat=${payload.chatId}&`)
        payload.page && (url += `page=${payload.page}&`)
        payload.perPage && (url += `per_page=${payload.perPage}&`)

        const response = await ChatApiService.get(url);
        return response.data;
    } catch {
        throw new Error("Ocorreu um erro ao requisitar mensagens")
    }
};

export const createMessage = async (payload = {}) => {
    try {
        const response = await ChatApiService.post('/messages', payload, {
            headers: {
                ...payload?.media && { 'Content-Type': 'multipart/form-data' }
            }
        });
        return response.data;
    } catch {
        throw new Error("Ocorreu um erro ao criar mensagem")
    }
};

export const createChat = async (payload = {}) => {
    try {
        const response = await ChatApiService.post('/chats', payload);
        return response.data;
    } catch {
        throw new Error("Ocorreu um erro ao criar chat")
    }
};

export const deleteMessage = async (messageId) => {
    try {
        const response = await ChatApiService.delete(`/messages/${messageId}`);
        return response.data;
    } catch {
        throw new Error("Ocorreu um erro ao excluir mensagem")
    }
};

export const updateMessage = async (messageId, payload) => {
    try {
        const response = await ChatApiService.put(`/messages/${messageId}`, payload);
        return response.data;
    } catch {
        throw new Error("Ocorreu um erro ao atualizar mensagem")
    }
};

export const viewMessage = async (messageId) => {
    try {
        const response = await ChatApiService.put(`/messages/${messageId}/view`);
        return response.data;
    } catch {
        throw new Error("Ocorreu um erro ao visualizar mensagem")
    }
};

export const connectToGlobalChatNotificationsChannel = (userId, events) => {
    const localChatServiceInstance = chatServiceReverb()
    if (!localChatServiceInstance) return
    try {
        const privateChannel = localChatServiceInstance.private(`chat.notifications.${userId}`)
        events.forEach((event) => {
            privateChannel.listen(event.eventName, (wsEvent) => {
                store.dispatch(event.eventAction, wsEvent)
            })
        })
    } catch {
        store.dispatch('toastfy/activeErrorNotification', { text: "Ocorreu um erro ao conectar no canal de notificações" })
    }
}

export default {
    getChatUsers,
    getSocialChats,
    getChatMessages,
    connectToGlobalChatNotificationsChannel
};
